export const marketingAssets = {
  campaign: new URL('../assets/campaign-sneaker.png', import.meta.url).href,
  character: new URL('../assets/character-memories-expanded.png', import.meta.url).href,
  coast: new URL('../assets/showcase-coast.png', import.meta.url).href,
  fashion: new URL('../assets/fragrance-campaign.png', import.meta.url).href,
  handoff: new URL('../assets/creative-handoff-anime.png', import.meta.url).href,
  space: new URL('../assets/showcase-space.png', import.meta.url).href,
  story: new URL('../assets/story-rooftop.png', import.meta.url).href
};
